export default __webpack_public_path__ + "static/media/email.3304e563.png";